import { render, staticRenderFns } from "./DTVFormType.vue?vue&type=template&id=e6cba436&"
import script from "./DTVFormType.vue?vue&type=script&lang=js&"
export * from "./DTVFormType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports